{
  "label": {
    "badge": "AI",
    "commentary_key": "AI = written by AI from the shot data",
    "written": "Written by AI from game results",
    "written_short": "Written by AI",
    "round_report": "Written by AI from your round",
    "words": "Words by AI",
    "show": "Written and voiced by AI, using this week's game results",
    "voiced": "Voiced by AI",
    "reporter": "AI reporter",
    "coach": "AI coach",
    "club": "AI-run club",
    "committee": "Explained by AI. Decided by the game's published rules.",
    "central_bank": "AI economy watch",
    "game_master": "Event idea from our AI game master",
    "caddie_intro": "{caddieName} is an AI character. Tips come from the game's numbers.",
    "assistant_intro": "You're chatting with our AI helper, not a person. Ask for a person at any time.",
    "explainer_title": "About AI in {gameName}",
    "art_credit": "Some artwork was made with AI image tools and finished by the {gameName} team.",
    "course_designer": "Made with our AI course designer",
    "design_helper": "Drafted by AI. You check it before it is sent.",
    "show_start": "The commentary in this show is written by AI."
  },
  "a11y": {
    "badge_golfer": "AI golfer: {name}",
    "paragraph": "Written by AI: {text}"
  }
}
